import { useNavigate } from "react-router-dom";
import TaskForm from "../../components/TaskForm";
import "./Tasks.css";

export default function CreateTask() {
  const navigate = useNavigate();

  return (
    <div className="main">
      <div className="tasks-main">
        <h1>Create Task</h1>
        <TaskForm onSuccess={() => navigate("/tasks")} />
      </div>

    </div>
  );
}
